// frontend/src/pages/Reinsurance/components/CedentManagement/index.js

import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useLanguage } from '../../../../contexts/LanguageContext';
import { CedentProvider } from '../../contexts/CedentContext';
import CedentList from './CedentList';
import CedentDetail from './CedentDetail';
import CedentCreate from './CedentCreate';
import CedentEdit from './CedentEdit';
import styles from './CedentManagement.module.css';

const CedentManagement = () => {
  const { t } = useLanguage();
  const location = useLocation();
  const navigate = useNavigate();
  const [view, setView] = useState('list');
  const [cedentId, setCedentId] = useState(null);
  
  useEffect(() => {
    const path = location.pathname;
    
    if (path === '/reinsurance/cedents') {
      setView('list');
    } else if (path === '/reinsurance/cedents/create') {
      setView('create');
    } else if (path.match(/\/reinsurance\/cedents\/[^/]+\/edit$/)) {
      const id = path.split('/').slice(-2)[0];
      setCedentId(id);
      setView('edit');
    } else if (path.match(/\/reinsurance\/cedents\/[^/]+$/)) {
      const id = path.split('/').pop();
      setCedentId(id);
      setView('detail');
    }
  }, [location.pathname]);
  
  const handleViewCedent = (id) => {
    navigate(`/reinsurance/cedents/${id}`);
  };
  
  const handleCreateCedent = () => {
    navigate('/reinsurance/cedents/create');
  };
  
  const handleEditCedent = (id) => {
    navigate(`/reinsurance/cedents/${id}/edit`);
  };
  
  const handleBackToList = () => {
    navigate('/reinsurance/cedents');
  };
  
  const handleBackToDetail = (id) => {
    navigate(`/reinsurance/cedents/${id}`);
  };
  
  const renderView = () => {
    switch (view) {
      case 'list':
        return (
          <CedentList 
            onViewCedent={handleViewCedent}
            onCreateCedent={handleCreateCedent}
          />
        );
      case 'detail':
        return (
          <CedentDetail 
            cedentId={cedentId}
            onBack={handleBackToList}
            onEdit={() => handleEditCedent(cedentId)}
          />
        );
      case 'create':
        return (
          <CedentCreate 
            onBack={handleBackToList}
            onSuccess={(id) => navigate(`/reinsurance/cedents/${id}`)}
          />
        );
      case 'edit':
        return (
          <CedentEdit 
            cedentId={cedentId}
            onBack={() => handleBackToDetail(cedentId)}
            onSuccess={(id) => navigate(`/reinsurance/cedents/${id}`)}
          />
        );
      default:
        return <CedentList />;
    }
  };
  
  return (
    <CedentProvider>
      <div className={styles.cedentManagement}>
        {renderView()}
      </div>
    </CedentProvider>
  );
};

export default CedentManagement;